import { SoftwareLabel } from './software-label';

export class SoftwarePlatform extends SoftwareLabel {}
